// eslint-disable-next-line import/prefer-default-export
export const bankSelects = {
  data() {
    return {
      bank_names: [
        { name: "Banco de Chile", code: 1 },
        { name: "Banco Internacional", code: 2 },
        { name: "Scotiabank Chile", code: 3 },
        { name: "Banco de Crédito e Inversiones", code: 4 },
        { name: "Banco Bice", code: 5 },
        { name: "Banco Santander-Chile", code: 6 },
        { name: "Itaú Corpbanca", code: 7 },
        { name: "Banco Security", code: 8 },
        { name: "Banco Falabella", code: 9 },
        { name: "Banco Ripley", code: 10 },
        { name: "Banco Consorcio", code: 11 },
        { name: "Banco Estado", code: 12 },
        { name: "Banco Coopeuch", code: 13 },
        { name: "MACH", code: 14 },
        { name: "TENPO", code: 15 },
      ],
      bank_account_types: [
        { type: "Cuenta Corriente", code: 1 },
        { type: "Cuenta Vista", code: 2 },
        { type: "Chequera Eléctronica", code: 3 },
        { type: "Cuenta de Ahorro", code: 4 },
      ],
      fund_origins: [
        { type: "Rentas del Trabajo", code: 1 },
        { type: "Acuerdos Legales", code: 2 },
        { type: "Inversiones", code: 3 },
        { type: "Herencia", code: 4 },
        { type: "Seguros", code: 5 },
        { type: "Pensiones", code: 6 },
        { type: "Familiares", code: 7 },
        { type: "Venta Activos", code: 8 },
      ],
    };
  },
};
